import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { FuseModule } from '@fuse/fuse.module';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { fuseConfig } from './app/fuse-config';
import { AuthenticationService } from './app/shared/authentication';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(BrowserModule, FuseModule.forRoot(fuseConfig), MatNativeDateModule),
        provideAppInitializer(() => {
            const initializerFn = ((authenticationService: AuthenticationService) => () => {
                return authenticationService.handleAuthentication();
            })(inject(AuthenticationService));
            return initializerFn();
        }),
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'outline',
                subscriptSizing: 'dynamic'
            }
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideRouter(routes)
    ]
})
    .catch(err => {
        const errorMsgElement = document.querySelector('#initialization-error');
        if (errorMsgElement) {
            errorMsgElement.innerHTML = `An error occurred during initialization.<br>Please try to reload in a few instants.<br>If the problem persists contact <a href="mailto:support@mediacliphub.com">support@mediacliphub.com</a>`;
        }
        const errorDetailsElement = document.querySelector('#error-details');
        if (errorDetailsElement) {
            errorDetailsElement.textContent = JSON.stringify(err, undefined, 2)
        }
        const spinnerElement = document.querySelector('#fuse-splash-screen .spinner-wrapper');
        if (spinnerElement) {
            spinnerElement.remove();
        }
        console.error(err);
    });
